import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ca1f31e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "min-h-screen pb-5 flex align-items-center justify-content-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/",
  class: "flex align-items-center mb-5 text-gray-900 no-underline",
  style: {"width":"230px"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/pifema-logo-dark.svg",
    width: "130"
  }),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text-2xl ml-2",
    style: {"padding-top":"0.2rem"}
  }, "SPOT")
], -1))
const _hoisted_3 = { class: "field" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "loginEmail" }, "Email", -1))
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "loginEmail" }, "Password", -1))
const _hoisted_7 = { class: "mt-2 flex flex-wrap justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_PrimevueCard = _resolveComponent("PrimevueCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PrimevueCard, { class: "sm:w-6 md:w-4 lg:w-3" }, {
      title: _withCtx(() => [
        _hoisted_2
      ]),
      content: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($options.submitHandler && $options.submitHandler(...args)), ["prevent"])),
          name: "loginForm"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_InputText, {
              class: _normalizeClass(["w-full", `${$setup.v$.email.$error ? 'bg-red-200' : ''}`]),
              invalid: $setup.v$.email.$error,
              modelValue: $data.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.email) = $event)),
              type: "email",
              name: "email",
              id: "loginEmail"
            }, null, 8, ["class", "invalid", "modelValue"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.email.$errors, (error, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "text-sm font-italic text-red-400"
              }, _toDisplayString(error.$message), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_InputText, {
              class: _normalizeClass(["w-full", `${$setup.v$.password.$error ? 'bg-red-200' : ''}`]),
              invalid: $setup.v$.password.$error,
              modelValue: $data.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.password) = $event)),
              type: "password",
              name: "password",
              id: "loginPassword"
            }, null, 8, ["class", "invalid", "modelValue"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.password.$errors, (error, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "text-sm font-italic text-red-400"
              }, _toDisplayString(error.$message), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_PrimevueButton, {
              type: "submit",
              label: "Prihlásiť sa",
              text: "",
              raised: ""
            })
          ])
        ], 32)
      ]),
      _: 1
    })
  ]))
}